import { isVNode } from './utils';
import { framesInit } from './frames';
import box from './box';
import Vue from 'vue';
import Layout from "./components/Layout";

    // frame实例表
let data = {},
    // 实例id
    id = 0;

function init() {

        // 父容器 
    var wrap = null;

        // 普通弹窗列表
    let list = [],
        // 队列弹窗表
        continuous_lists = {},
        // 弹窗构造实例
        groupFrame = create_frame();
    
    // 新建实例
    data[id] = {
        id,
        list,
        continuous_lists,
        groupFrame
    }

    /**
     * 生成弹窗实例
     * @returns {Object} 多种类型弹窗构造函数
     */
    function create_frame () {

        /**
         * 显示弹窗 
         * @param {*} mine 组件对象
         * 
         * @returns {Function} 包装后的构造弹窗函数
         */
        function create_call(mine){
            
            /**
             * 递归查找当前vue实例下的特殊名字的子组件
             * @param {*} vm vue实例
             * @param {*} name 名字
             * 
             * @returns {Object} 找到了就是vue实例 找不到就是null
             */
            function getVmByName(vm,name) {
                function fresh(children) {
                    for (let i = 0; i < children.length; i++) {
                        const v = children[i];
                        if (v.$options.name === name)
                            return v
                        else
                            return v.$children.length != 0 ? fresh(v.$children) : null
                    }
                }

                return fresh(vm.$children)
            }

            /**
             * 构造vue实例
             * @param {*} obj 
             * 
             * @returns {Object} vue实例
             */
            function initInstance (obj) {

                let el = document.createElement('div')

                var Vm = Vue.extend({
                    name: 'frame',
                    // 弹窗组件标记
                    _isFrame: true,
                    data: _=>({
                        show: false,
                        resizeData: null
                    }),
                    methods: {
                        layerShow() {
                            this.show = true
                        },
                        layerHide() {
                            this.show = false
                        },
                        resize(_) {
                            this.resizeData = _
                        }
                    },
                    render: function (h) {
                        obj.mask === undefined && (obj.mask = true)
                        if (!obj.mask)
                            return <mine show={this.show} {...{ attrs: obj }}/>
                        else
                            return <Layout show={this.show} vResize={this.resize}>
                                <mine show={this.show} resizeData={this.resizeData} {...{ attrs: obj }}/>
                            </Layout> 
                    },
                    directives: {
                        resize: {
                            // 监听元素/DOM尺寸变化
                            bind: function (el, binding) {
                                let width = '',
                                    height = '';
                        
                                const resizeObserver = new ResizeObserver(entries => {
                                    const style = window.getComputedStyle(el, null),
                                        n_width = parseFloat(style.width),
                                        n_height = parseFloat(style.height);
                        
                                    if (width !== n_width || height !== n_height) {
                                        binding.value({
                                            width: n_width,
                                            height: n_height
                                        });
                                        
                                        width = n_width;
                                        height = n_height;
                                    }
                                });
                        
                                resizeObserver.observe(el);
                        
                                el.__resizeObserver__ = resizeObserver
                            },
                            unbind: function (el) {
                                el.__resizeObserver__.unobserve(el)
                            }
                        }
                    },
                    destroyed() {
                        this.$el.parentNode && this.$el.parentNode.removeChild(this.$el)
                    }
                });
        
                return new Vm({el});
            }

            /**
             * 将vue实例插入父容器，绑定事件
             * @param {*} target 
             * 
             * @returns {Object} 当前弹窗的状态 关闭事件 监听关闭事件或者其他自定义事件
             */
            function set_instance (target) {

                let inner_ins = target.instance,
                    instance = getVmByName(inner_ins,target.mine.name);

                // 插入父容器
                if (!instance.exist && target.wrap) {

                    let el = inner_ins.$el
                    
                    if (el && !target.wrap.contains(el)) {
                        target.wrap.appendChild(el)
                    };

                    instance.exist = true;
                    inner_ins.layerShow();

                    // 弹窗层级默认 300
                    inner_ins.$nextTick(_=>{
                        let zIndex = target.obj.zIndex || '9999999'
                        inner_ins.$el.style && (inner_ins.$el.style.zIndex = zIndex);
                    })
                }
                
                // 监听弹窗手动关闭
                target.watch = instance.$watch('exist', function(newDate) {
                    if (!newDate) {

                        inner_ins.layerHide();

                        // 动画结束后
                        setTimeout(_=>{
                        
                            inner_ins.$destroy()

                            let continuous_list = continuous_lists[target.continuous_id || target.id]

                            // 找到当前删除实例的角标
                            let index = list.findIndex(el=>target.id == el.id);
                                
                            list.splice(index,1)

                            if (target.continuous && continuous_list.length > 0) {

                                index = continuous_list.findIndex(el=>target.id == el.id);

                                continuous_list.splice(index,1)

                                let item = continuous_list[index-1]

                                item && (item.instance.layerShow())
                            }
                        },200)
                    }    
                }, { immediate: false })
                
                let struct = {
                    // 关闭
                    close: instance.close
                }
                
                // _exist 表示是否存在
                Object.defineProperty(struct, '_exist', {
                    get() { return instance.exist },
                    set(v) { console.error('_exist is not writable') },
                })

                // 额外监听事件列表
                let ons = target.obj.ons || [];

                let fns = {
                    onClose: null
                }

                ons.forEach(el=>fns[el] = null)

                // 监听当返回对象写入事件时将事件绑定
                for (const key in fns) {
                    Object.defineProperty(struct, key, {
                        get() { return fns[key]; },
                        set(fn) { 
                            // 如果是函数才绑定
                            if (fn && fn.constructor == Function) {
                                instance.$off(key);
                                instance.$on(key, function (...args) {
                                    let result = fn(...args)
                                    key == 'onClose' && result !== false && struct.close(true)
                                })
                            }
                        }
                    })
                }

                // 如果是队列弹窗 则将构造弹窗的方法绑定在弹窗实例上
                if (target.continuous)
                    for (const key in groupFrame) {
                        const fn = groupFrame[key];
                        struct[key] = (content,obj)=>{
                            return fn(content,{
                                ...obj,
                                continuous: true,
                                continuous_id: target.continuous_id || target.id
                            })
                        }
                    }

                return struct
            }

            let frame_id = 0;

            return function (obj) {

                let continuous_id = obj.continuous_id;

                var target = {
                    // 例 0_box_0
                    id: id + '_' + mine.name + '_' + (frame_id ++),
                    continuous_id: obj.continuous_id || undefined,
                    // 父容器
                    wrap: obj.vm ? obj.vm.$el : wrap,
                    // 传入的参数对象
                    obj,
                    // 弹窗类型
                    mine,
                    // 监听显示隐藏字段改变
                    watch: null,
                    // 弹窗实例
                    instance: initInstance(obj),
                    // 列表
                    list,
                    // 重叠
                    overlap: obj.overlap || false,
                    // 队列
                    continuous: obj.continuous || false
                }
                
                // 默认新弹窗会顶掉其他弹窗
                if (!target.overlap && !target.continuous) {
                    list.forEach((el,i)=>{
                        if (!el.overlap && !el.continuous){
                            let item = getVmByName(el.instance,el.mine.name)
                            item && (item.exist = false)
                        }
                    })
                }
                
                // 隐藏队列中的弹窗
                if (target.continuous) {

                    let _list = continuous_lists[continuous_id || target.id]

                    if (_list) {
                        _list.forEach(el=>{
                            el.instance.layerHide();
                        })

                        _list.push(target);
                    } else
                        continuous_lists[target.id] = [target];
                    
                } else {
                    // 添加到列表
                    list.push(target);
                }
        
                return set_instance(target)

            }
        }

        // 包装后的构造自定义弹窗函数
        let frame_box = create_call(box)

        // 自定义弹窗参数检测
        function validate_box (...args) {
            let obj = {
                component: null
            };

            let first = args[0],
                second = args[1],
                cons = first?.constructor,
                cons_2 = second?.constructor;
                
            if (cons_2 == Object)
                obj = { ...second, ...obj }
            else if(!second && second !== undefined)
                console.error("The second argument of the box method must be an object")
            
            if (cons == Object && first.render) 
                obj.component = first
            else    
                console.error("The first argument of the box method must be an object")

            return frame_box(obj)
        }

        return {
            ...framesInit(validate_box),
            box: validate_box,
        }
    }

    // 设置父容器引用
    function set_wrap (dom) {
        wrap = dom
    }

    // 销毁
    var destroy = function () {

        try {
            // 销毁所有弹窗
            list.forEach(v => {
                v.instance.$destroy()
            });
            
            // 销毁所有队列弹窗
            for (const key in continuous_lists) {
                continuous_lists[key].forEach(v => {
                    v.instance.$destroy()
                })
            }
        } catch (e) {
            console.error(e)
        }

        delete data[id]

        wrap = null
    }

    // 递增id
    id ++ 

    return {
        set_wrap,
        destroy,
        ...groupFrame
    }
}

export default init



